import { IKeyValue } from "../models/ikeyvalue.interface";

export class GLOBAL_CONVERTERS  {

  constructor() { }

  static stgetUniqueKeyValueArray(arr: IKeyValue[]): any[] {
    const uniqueValues: IKeyValue[] = [];

    arr.forEach(element => {
      const res = uniqueValues.find(o => o.id === element.id);
      if (!res) {
        uniqueValues.push(element);
      }
    });

    return uniqueValues;
  }



  static getUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  static getDateFromString(str: string): Date {
    const year = +str.substr(6, 4);
    const month = +str.substr(3, 2) - 1;
    const day = +str.substr(0, 2);
    const date = new Date(year, month, day);
    return date;
  }

  static getStringFromDate(d: Date): string {
    const month = (d.getMonth() + 1).toString();
    const day = d.getDate().toString();
    return `${+day < 10 ? '0' + day : day }-${+month < 10 ? '0' + month : month}-${d.getFullYear()}`;
  }
  static getStringFromDateTime(d: Date): string {
    const month = (d.getMonth() + 1).toString();
    const day = d.getDate().toString();
    const hours = d.getHours().toString();
    return `${+day < 10 ? '0' + day : day }-${+month < 10 ? '0' + month : month}-${d.getFullYear()} ${+hours < 10 ? '0' + hours : hours }:${d.getMinutes()}`;
  }

  static replaceDateStringToIsoFormat(str: string) {
    return str.replace( /(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3');
  }

  static getBytesToSize(bytes): string {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) { return 'n/a'; }
    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)).toString(), 10);
    if (i === 0) { return `${bytes} ${sizes[i]}`; }
    return `${(bytes / (1024 ** i)).toFixed(1)} ${sizes[i]}`;
  }

}
